import webApi, { baseURL } from "../../WebApi/WebApi";

//VAT ADD
export const getVat = async (countryId,vatId, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/vat/add-vat`, {
                countryId,
                vatId,
            // country: country,

        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};


//LIST VAT 

export const getAllVatlist = async (data) => {
    return await webApi.get(`/customer/vat/list-vat`,
    );
}
//LIST VAT 

export const getMyAllVatlist = async (data) => {
    return await webApi.get(`/customer/vat/vat-list`,
    );
}


//DELETE VAT
export const deleteVat = async (vatId, onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/vat/delete-vat`, {
                countryId: Number(vatId),

        }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};

//vat id by details


export const getVatByid = async (data) => {
    console.log(data, "datata")
    return await webApi.post(`/customer/vat/get-vat-by-id`,
        {
            vatId: data
        });
}

//update or edit vat

export const getUpdateVat = async (vatId,country,vat,onSuccess, onFailure) => {
    try {
        const res = await webApi.post(
            `/customer/vat/edit-vat`, {
                vatId:vatId,
                country:country,
                vat:vat
            }
        );
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};
export const ListCountry = async (onSuccess, onFailure) => {
    try {
        const res = await webApi.get(`/customer/vat/list-vat`);
        if (res.status === 200) {
            const r = res.data;
            return onSuccess(r);
        } else {
            onFailure("Something Wrong! Please Try again later" + res.data);
        }
    } catch (error) {
        console.log("fdgdf")
    }
};

